module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.doneLoading) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-map', {
    attrs: {
      "zoom": _vm.zoom,
      "center": _vm.center
    }
  }, [_c('v-tilelayer', {
    attrs: {
      "url": _vm.url,
      "attribution": _vm.attribution
    }
  }), _vm._v(" "), _vm._l((_vm.markers), function(item) {
    return _c('div', [_c('v-marker', {
      attrs: {
        "lat-lng": item.coordinates,
        "icon": item.icon
      }
    }, [_c('v-popup', {
      attrs: {
        "content": item.popup
      }
    }), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "content": item.tooltip,
        "options": _vm.options
      }
    })], 1)], 1)
  })], 2)], 1) : _c('div', [_vm._v("\n    Henter kort...\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3998ba3f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MapComponent.vue
// module id = 1008
// module chunks = 1